/* Maps keypad keys to Mathquill commands */

export default {
  // Symbols
  'x^{}': ['^'],
  'x_{}': ['_'],
  '\\sqrt{}': ['\\sqrt'],
  '\\sqrt[]{}': ['\\nthroot'],
  // Fractions
  '\\frac{x}{}': ['/'],
  'x\\frac{x}{}': ['\\frac'],
  // Calculus
  'int_{}': ['\\int', '_'],
  '\binom{}{}': ['\\binom'],
  // Delimiters
  '({})': ['('],
  '[{}]': ['['],
  '|{}|': ['|'],
  // Geometry & Trigonometry
  '\\overline{x}': ['\\overline'],
  '\\circ': ['^', '\\circ'],
  // Chemistry
  '\\text{H}^{}': ['^'],
  '\\text{H}_{}': ['_'],
  // Math Mode
  T: ['\\mathrm'],
};
